export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-24',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
